import { type ReactNode } from 'react';
import { Input } from '@/components/ui/input';
import { Select } from '@/components/ui/select';
import type { UserRole } from '@/types/auth';

type Form = {
  ig_username: string;
  personal_ig_username: string;
  role: UserRole;
};

type Props = { f: Form; set: (k: keyof Form, v: string) => void };

function RoleSelect({ f, set }: Props): ReactNode {
  return (
    <Select
      label="Rol"
      value={f.role}
      onChange={(e) => set('role', e.target.value)}
    >
      <option value="collector">Collector</option>
      <option value="approacher">Approacher</option>
      <option value="mago">Mago</option>
      <option value="admin">Admin</option>
    </Select>
  );
}

export function AccountSection({ f, set }: Props): ReactNode {
  return (
    <div className="grid grid-cols-2 gap-sm">
      <Input
        label="Instagram personal"
        value={f.personal_ig_username}
        onChange={(e) => set('personal_ig_username', e.target.value)}
      />
      <RoleSelect f={f} set={set} />
      <div className="col-span-2">
        <Input
          label="Instagram de jugador (opcional)"
          value={f.ig_username}
          onChange={(e) => set('ig_username', e.target.value)}
        />
      </div>
    </div>
  );
}
